







import Vue from 'vue';
import JitCoinBanner from '../components/jitcoin/banner.vue';

export default Vue.extend({
	components: {
		JitCoinBanner
	}
});
